import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c70ba3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "analysis" }
const _hoisted_2 = { class: "analysis-top" }
const _hoisted_3 = { class: "bottom-body" }
const _hoisted_4 = { class: "analysis_top" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px","color":"#ef5350","margin-top":"10px"} }, "附件题的文件资源仅保留30天，如有需要请及时下载。", -1))
const _hoisted_9 = {
  key: 0,
  class: "analysis_table"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "analysis_table"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  class: "charts-box"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around","position":"relative"}
}
const _hoisted_18 = {
  ref: "videoRef",
  id: "videojs-player",
  controls: "",
  class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_c_del_modal = _resolveComponent("c-del-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_tabs, {
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
        onChange: _ctx.itemClick
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (numbers) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: numbers,
              tab: '第' + numbers + '题'
            }, null, 8, ["tab"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeKey", "onChange"]),
      _createElementVNode("div", {
        class: "analysis_export",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.quesExport()))
      }, [
        _createVNode(_component_UploadOutlined, { class: "icon" }),
        _createTextVNode("导出所有")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _createTextVNode(" 题目：" + _toDisplayString(_ctx.item_config.title) + " ", 1),
            (_ctx.item_config.remark)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "（" + _toDisplayString(_ctx.item_config.remark) + "）", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.item_config.type != 7)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "填写率" + _toDisplayString(_ctx.item_config.fill_prop) + " / 填写量" + _toDisplayString(_ctx.item_config.fill_count), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (_ctx.item_config.type == 3 || _ctx.item_config.type == 4)
            ? (_openBlock(), _createBlock(_component_a_input_search, {
                key: 0,
                value: _ctx.keyword,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keyword) = $event)),
                placeholder: "搜索关键字",
                "enter-button": "",
                size: "large",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.items_analysis()))
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.item_config.type == 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_a_button, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.questDelClick(1, ''))),
                style: {"margin-right":"20px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除所有")
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.questEncExport()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出所有")
                ]),
                _: 1
              }),
              _hoisted_8
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.item_config.type == 3 || _ctx.item_config.type == 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_a_table, {
              loading: _ctx.showLoading,
              columns: _ctx.textColumns,
              pagination: _ctx.pagination,
              "data-source": _ctx.textData,
              rowKey: 
            (res,index) => {
              return index;
            }
          
            }, {
              avatar_url: _withCtx(({ record }) => [
                _createElementVNode("img", {
                  class: "analysis_table_img",
                  src: record.avatar_url
                }, null, 8, _hoisted_10)
              ]),
              _: 1
            }, 8, ["loading", "columns", "pagination", "data-source", "rowKey"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.item_config.type == 6)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_a_table, {
              loading: _ctx.showLoading,
              columns: _ctx.enclosureColumns,
              "data-source": _ctx.enclosureData,
              pagination: _ctx.pagination,
              rowKey: 
            (res) => {
              return res.id;
            }
          
            }, {
              avatar_url: _withCtx(({ record }) => [
                _createElementVNode("img", {
                  class: "analysis_table_img",
                  src: record.avatar_url
                }, null, 8, _hoisted_12)
              ]),
              operation: _withCtx(({ record }) => [
                (record.ext != 'pdf')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "file-operation",
                      onClick: ($event: any) => (_ctx.viewFile(record))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.documentPreview,
                        class: "img_ww cursor"
                      }, null, 8, _hoisted_14),
                      (record.ext == 'png' || record.ext == 'jpg' || record.ext == 'jpeg' || record.ext == 'gif')
                        ? (_openBlock(), _createBlock(_component_a_image, {
                            key: 0,
                            width: 14,
                            src: record.file_url
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_13))
                  : _createCommentVNode("", true),
                _createVNode(_component_svg_icon, {
                  class: "mod_select_icon cursor primary_color_blue",
                  "icon-class": "del",
                  style: {"margin":"0 20px"},
                  onClick: ($event: any) => (_ctx.questDelClick(0, record.id))
                }, null, 8, ["onClick"]),
                _createVNode(_component_svg_icon, {
                  class: "mod_select_icon cursor primary_color_blue",
                  "icon-class": "downloads",
                  onClick: ($event: any) => (_ctx.downLoad(record.file_url))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["loading", "columns", "data-source", "pagination", "rowKey"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showCharts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.AnalysisEchars), { item_config: _ctx.item_config }, null, 8, ["item_config"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_c_del_modal, {
      visible: _ctx.deletesInfo.show_modal,
      centered: "",
      close: _ctx.openDelModal,
      ok: _ctx.questDetailEncDel
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将删除该文件，是否继续？")
      ]),
      _: 1
    }, 8, ["visible", "close", "ok"]),
    _createVNode(_component_a_modal, {
      centered: "",
      visible: _ctx.fileInfo.audio_modal,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fileInfo.audio_modal) = $event)),
      footer: null,
      class: "audio-modal",
      onCancel: _ctx.videocancel,
      width: 1050,
      closable: false
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("audio", {
          controls: "",
          autoplay: "",
          src: _ctx.fileInfo.audio_url,
          style: {"display":"block","margin":"0 auto"}
        }, null, 8, _hoisted_16), [
          [_vShow, _ctx.fileInfo.isAudio]
        ]),
        (_ctx.playStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("video", _hoisted_18, null, 512),
              _createElementVNode("div", {
                style: {"position":"absolute","top":"-20px","right":"-14px","cursor":"pointer"},
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.videocancel && _ctx.videocancel(...args)))
              }, "✖")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ]))
}